<div class="modal fade" bsModal #changePasswordModal="bs-modal" [config]="{backdrop: 'static',keyboard: false}" 
     tabindex="-1" role="dialog" aria-hidden="true">
    
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-xs-left">{{titleText}}</h4>
            </div>
            <div class="modal-body"> 
                    <div class="row form-spacer">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="password">Enter old password:</label>
                                    <input type="password" maxlength="50"  
                                           [(ngModel)]="oldPassword"
                                           (ngModelChange)="oldPasswordChange()"
                                           class="{{ isIncorrectPasswordError ? 'form-control red-text-border': 'form-control '}}"                                       
                                    >
                                    <div class="row form-spacer col-12" [hidden] = "!isIncorrectPasswordError" [style.color]="'red'" >
                                            Incorrect password.
                                        </div>
                                </div>
                            </div>
                        </div>                            
                <div class="row form-spacer">
                    <div class="col-12">
                        <div class="form-group">
                            <label for="password">Enter new password:</label>
                            <input type="password" maxlength="50"                                   
                                   [(ngModel)]="newPassword"
                                   (ngModelChange)="newPasswordChange()"
                                   (focusout)="validatePasswordRule()"
                                   class="{{ (isValidPasswordError || isSamePassword || isPasswordHistoryViolation) ? 
                                    'form-control red-text-border': 'form-control '}}"
                                   />
                                   <div class="row form-spacer col-12"  class="{{isValidPasswordError ? 'error-text': 'help-text'}}" >
                                    Password must be at least 8 characters and contain at least one number and one special character.
                                  </div>
                      </div>
                    </div>
                </div>
                <div class="row form-spacer">
                  <div class="col-12">
                      <div class="form-group">
                        <label for="password">Confirm new password:</label>
                        <input type="password" maxlength="50"                                        
                               [(ngModel)]="confirmPassword"
                               (ngModelChange)="confirmPasswordChange()"                                      
                               class="{{ (isError || isSamePassword || isPasswordHistoryViolation) ? 
                                      'form-control red-text-border': 'form-control '}}"
                               />
                        <div class="row form-spacer col-12 error-text" 
                              [hidden] = "(!isError && !isSamePassword && !isPasswordHistoryViolation)" [style.color]="'red'" >
                                {{errorDisplayMessage}}
                        </div>
                    </div>
                  </div>
                </div>
                   
                    <div class="row form-spacer">
                            <div class="{{closeButton ? 'col-6 text-align-left' : 'col-12 text-align-left'}}" *ngIf = "closeButton">                                                         
                                    <button class="btn btn-primary" [disabled]="passwordSubmitted" (click)="closeModal(changePasswordModal)">Cancel</button>                           
                            </div> 
                        <div class="{{closeButton ? 'col-6 text-align-right' : 'col-12 text-align-right'}}">                                                         
                                <button class="btn btn-primary" (click)="savePassword()" [disabled]="!canSave() || passwordSubmitted"> {{passwordSubmitted ? "Saving New Password..." : "Save New Password"}}</button>                           
                        </div>                
        
                    </div>
       
        </div>
    </div>
</div>
<div>
    <my-authentication-handler-modal>
    </my-authentication-handler-modal>
</div>